import React from 'react';

const TIPOS = {
  STOCK_INICIAL: {
    nombre: 'Stock inicial',
    clase: 'bg-azul-lago/15 text-azul-oscuro',
  },
  ENTRADA: {
    nombre: 'Reposición',
    clase: 'bg-verde-esmeralda/15 text-verde-oscuro',
  },
  AJUSTE: {
    nombre: 'Ajuste',
    clase: 'bg-amarillo-dorado/20 text-azul-oscuro',
  },
  VENTA: {
    nombre: 'Venta',
    clase: 'bg-gris-piedra/25 text-azul-oscuro',
  },
  ANULACION_VENTA: {
    nombre: 'Anulación de venta',
    clase: 'bg-red-100 text-red-700',
  },
};

const numero = (valor) => {
  const n = Number(valor || 0);

  return Number.isInteger(n)
    ? String(n)
    : n.toLocaleString('es-AR', {
        maximumFractionDigits: 3,
      });
};

const fechaHora = (valor) => {
  if (!valor) return '—';

  return new Date(valor).toLocaleString('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
};

export default function MovimientosStockTable({
  movimientos,
  cargando,
  error,
}) {
  if (cargando) {
    return (
      <div className="rounded-2xl bg-white p-8 text-center text-sm text-slate-500 shadow-xl">
        Cargando movimientos...
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-2xl bg-white p-8 text-center text-sm text-red-600 shadow-xl">
        {error}
      </div>
    );
  }

  if (!movimientos.length) {
    return (
      <div className="rounded-2xl bg-white p-8 text-center text-sm text-slate-500 shadow-xl">
        Todavía no hay movimientos de stock.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-xl">
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-azul-oscuro text-white">
            <tr>
              <th className="px-4 py-3 font-semibold">Fecha</th>
              <th className="px-4 py-3 font-semibold">Producto</th>
              <th className="px-4 py-3 font-semibold">Movimiento</th>
              <th className="px-4 py-3 text-right font-semibold">
                Cantidad
              </th>
              <th className="px-4 py-3 text-center font-semibold">
                Stock
              </th>
              <th className="px-4 py-3 font-semibold">Usuario</th>
              <th className="px-4 py-3 font-semibold">Motivo</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100">
            {movimientos.map((movimiento) => {
              const tipo = TIPOS[movimiento.tipo] || {
                nombre: movimiento.tipo,
                clase: 'bg-slate-100 text-slate-700',
              };

              const cantidad = Number(movimiento.cantidad || 0);

              return (
                <tr
                  key={movimiento.id}
                  className="transition hover:bg-slate-50"
                >
                  <td className="whitespace-nowrap px-4 py-3 text-slate-500">
                    {fechaHora(movimiento.created_at)}
                  </td>

                  <td className="px-4 py-3">
                    <div className="font-semibold text-azul-oscuro">
                      {movimiento.producto?.nombre || 'Producto'}
                    </div>

                    {movimiento.producto?.codigo && (
                      <div className="text-xs text-slate-400">
                        {movimiento.producto.codigo}
                      </div>
                    )}
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ${tipo.clase}`}
                    >
                      {tipo.nombre}
                    </span>
                  </td>

                  <td
                    className={`whitespace-nowrap px-4 py-3 text-right font-bold ${
                      cantidad > 0
                        ? 'text-verde-oscuro'
                        : cantidad < 0
                          ? 'text-red-600'
                          : 'text-slate-600'
                    }`}
                  >
                    {cantidad > 0 ? '+' : ''}
                    {numero(cantidad)}
                  </td>

                  <td className="whitespace-nowrap px-4 py-3 text-center font-semibold text-slate-700">
                    {numero(movimiento.stock_anterior)}
                    <span className="mx-2 text-slate-300">→</span>
                    {numero(movimiento.stock_posterior)}
                  </td>

                  <td className="px-4 py-3 text-slate-600">
                    {movimiento.usuario?.nombre || '—'}
                  </td>

                  <td className="max-w-xs px-4 py-3 text-slate-500">
                    {movimiento.motivo || '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
